// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"dc444d1f","141":"651e45f2","434":"016ff48b","497":"caa0a177","660":"4e918c66","886":"e5f944c1","954":"e9f88af2","962":"035f0ce1"}[chunkId] + ".chunk.css";
};